<template>
    <div :class="parentClasses">
        <div class="review-heading">
            <div id="border"></div>
            <div id="heading">Latest Reviews</div>
        </div>
        <div v-if="latestReviews.length" class="pr-2 thin-scroller review-container">
            <div v-for="review of latestReviews" :key="review.person_name+review.review_link" title="Click to see the review" class="section-card my-3 px-4 py-3">
                <a :href="review.review_link" target="_blank" style="text-decoration: none; color: black;">
                    <div class="d-inline-flex justify-content-between align-items-center w-100">
                        <div>
                            <span class="mr-3">
                                <img src="../../../../public/Icons_SVG/profile-svg.svg" width="40">
                            </span>
                            <span style="font-size: 15px; font-weight: 600; letter-spacing: 0;">{{ review.person_name }}</span>
                        </div>
                        <span class="d-inline-flex">
                            <IconStar v-for="i in review.rating" :key="i" class="star" />
                        </span>
                    </div>
                    <div style="padding-block: 6px; margin-block: 16px;">
                        "{{ review.review }}"
                    </div>
                    <div class="d-flex justify-content-between">
                        <div style="font-size: 14px; color: #5e5e5e;">{{ formatReviewDate(review.date) }}</div>
                        <div>
                            <span v-if="review.category" class="px-2 py-1" style="color: #5e5e5e; border: 1px solid #5e5e5e; border-radius: 10px; text-transform: capitalize;">{{ review.category.replaceAll("_", " ") }}</span>
                            <span v-if="review.product_id" class="px-2 py-1 ml-1" style="color: #5e5e5e; border: 1px solid #5e5e5e; border-radius: 10px; text-transform: capitalize;">{{ review.product_id }}</span>
                            <span v-if="review.sub_category">{{ review.sub_category }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-else class="noData mt-2 mb-3">No Data</div>
    </div>
</template>
<script>
import moment from 'moment';
import IconStar from '../../../assets/IconStar.vue';
export default {
    name: "LatestReviews",
    components: {
        IconStar
    },
    data() {
        return {

        }
    },
    props: {
        latestReviews: {
            type: Array,
            required: true
        },
        parentClasses: {
            type:  String
        }
    },
    methods: {
        formatReviewDate(date) {
            return moment(date).format("MMM DD, YYYY")
        }
    }

}
</script>
<style>
.review-container {
    max-height: 694px; 
    overflow-y: auto;
    border-bottom-left-radius: 10px; 
    border-bottom-right-radius: 10px; 
}

.thin-scroller::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 6px;
    background: #EBEDEE;
}

.thin-scroller::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.thin-scroller::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #B3B2B9;
}

.thin-scroller::-webkit-scrollbar-thumb:hover {
    background: #8B8D94;
    cursor: pointer;
}
.star {
    display: flex;
    width: 16px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}
.review-heading {
    display: grid;
    align-items: center;

    &>* {
        grid-column: 1;
        grid-row: 1;
    }
}

#heading {
    justify-self: center;
    background-color: white;
    font-size: 20px;
    font-weight: 500;
    line-height: 27.2px;
    letter-spacing: -0.01em;
    color: #5E5E5E;
    padding: 4px 8px;
}

#border {
    height: 1px;
    border: 1px solid #D9D9D9;
}

.section-card {
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    background-color: transparent;
    padding: 8px 16px;
    height: 100%;
}

@media (max-width: 1920px) and (min-width: 1620px) {
    .review-container {
        max-height: 670px;
    }
}
@media (max-width: 1620px) and (min-width: 1440px) {
    .review-container {
        max-height: 650px;
    }
}
</style>